import React, { useEffect, useState, useCallback } from "react";
import "./EnrollForm.css";
import Header from "./header/header";
import Footer from "./Footer";
import axios from "axios";
import { useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ClipLoader } from "react-spinners";
import { ICertificate } from "./EnrollTypes";
import { ICourseDetails } from "./EnrollTypes";
import { useNavigate } from "react-router-dom";
import { useCourses } from "./Contexts/CoursesContext";
import { baseUrl, GetToken } from "../App";

const VerifyCert: React.FC = () => {
	const {courses} = useCourses();
  const [ready, setReady] = useState(false);
  const [user, setUser] = useState<ICertificate | null>(null);
  const [fullNamePrefix, setFullNamePrefix] = useState("");
  const [course, setCourse] = useState<ICourseDetails | null>(null);
  const [userExist, setUserExist] = useState(false);
  let params = useParams();
  let navigate = useNavigate();
  const userId = params["id"];
  const gotoEnroll = (courseName: string) => {
	const slug = courseName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    navigate("/enroll/" + slug);
  };

  const getUserAndCourseData = useCallback(async (userId: string) => {
    try {
      const idToken = await GetToken();

      // Fetch all certificates
      const certificateResponse = await axios.get(
        `${baseUrl}/certificate`,
        {
          headers: { Authorization: `Bearer ${idToken}` },
        }
      );
      const allCertificates = certificateResponse.data;
      const userData = allCertificates.find(
        (cert: ICertificate) => cert.id === userId
      );
      //console.log(userData)
      if (userData) {
        setUser(userData);
        setUserExist(true);

        // Fetch course details if course name matches
        if (userData.coursename) {
          const courseData:any = courses?.find(
            (course: any) => course.CourseName === userData.coursename
          );
          setCourse(courseData);
        }
      }
      setReady(true);
    } catch (error: any) {
      console.error(
        "Error getting user details and course data:",
        error.message
      );
      setReady(true);
    }
  }, [courses]);

  useEffect(() => {
    if (userId) {
      getUserAndCourseData(userId);
    } else {
      console.log("No User ID found.");
      setReady(true);
    }
  }, [userId, getUserAndCourseData]);

  useEffect(() => {
    if (user?.studentname) {
      const names = user.studentname.trim().split(" ");
      setFullNamePrefix(
        `${names[0].slice(0, 1)}${
          names.length > 1 ? names[names.length - 1].slice(0, 1) : ""
        }`
      );
    }
  }, [user]);

  return (
    <div className="">
      {ready ? (
        <>
          <Header />
          {userExist ? (
            <div className="flex flex-col justify-center items-center w-full mt-16 bg-[#F4F8F8]">
              <div className="mt-20 flex flex-col lg:flex-row xl:flex-row justify-center gap-4 p-10">
                <div className="flex flex-col">
                  <div className="flex flex-grow flex-col lg:flex-row xl:flex-row justify-center gap-10 items-center bg-white p-4 rounded-lg">
                    <div className="flex text-2xl justify-center items-center border-2 p-2 rounded-full border-[#156614] bg-[#156614]">
                      <h5
                        className="m-0"
                        style={{
                          color: "#ffffff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                          width: "100%",
                          fontSize: "38px",
                        }}
                      >
                        {fullNamePrefix}
                      </h5>
                    </div>

                    <div>
                      <p className="text-xl font-bold">
                        Completed by {user?.studentname}
                      </p>
                      <p>{user?.dateofc}</p>
                      <p>
                        {user?.studentname}'s account is verified. Doyenify
                        Academy attests to the successful completion of the{" "}
                        {user?.coursename} course.
                      </p>
                    </div>
                  </div>

                  {course && (
                    <div className="flex flex-grow flex-col lg:flex-row xl:flex-row justify-center gap-6 items-center bg-white p-4 rounded-lg mt-4">
                      <div className="flex flex-col lg:flex-row xl:flex-row gap-4">
                        <div className="flex justify-center items-center">
                          <img
                            src="../../images/frame.png"
                            alt="course-logo"
                            className="flex-shrink-0"
                          />
                        </div>
                        <div className="flex flex-col">
                          <div className="flex gap-4 items-start justify-between mb-2">
                            <p className="text-lg font-bold">
                              {course.CourseName}
                            </p>
                            <button
                              className="btn btn-success flex mx-auto"
                              style={{ fontSize: "14px" }}
                              onClick={() => {
                                gotoEnroll(course?.CourseName || " ");
                              }}
                            >
                              Enroll
                            </button>
                          </div>
                          <p>{course.ShortDescription}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {/* <div
            className="container"
            style={{ marginTop: "50px", marginBottom: "20px" }}
          > */}
                <div
                  className="container"
                  style={{
                    width: "100%",
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                >
                  <svg
                    version="1.1"
                    id="PRINT"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 870.2 623.6"
                    enable-background="new 0 0 870.2 623.6"
                    xmlSpace="preserve"
                  >
                    <g>
                      <rect
                        x="0"
                        y="0"
                        fill="#FFFFFF"
                        width="870.2"
                        height="623.6"
                      />
                      <g>
                        <polygon
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          fill="#F1CE55"
                          points="219.5,294.3 209,304.8 219.5,315.3 		"
                        />
                        <polygon
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          fill="#F1CE55"
                          points="650.7,294.3 661.2,304.8 650.7,315.3 		"
                        />
                      </g>
                      <rect
                        x="25.8"
                        y="26"
                        fill="none"
                        stroke="#A5A5A5"
                        stroke-width="2.0317"
                        stroke-miterlimit="10"
                        width="818.5"
                        height="571.7"
                      />
                      <polygon
                        fill="#49803F"
                        points="870.2,413.2 743.4,623.6 870.2,623.6 	"
                      />
                      <polygon
                        fill="#A5A5A5"
                        points="700.5,623.6 759.4,623.6 838.3,492.7 779.4,492.7 	"
                      />
                      <polygon
                        fill="#A5A5A5"
                        points="669.8,623.6 681.7,623.6 870.2,310.7 870.2,291.1 	"
                      />
                      <polygon
                        fill="#A5A5A5"
                        points="163.6,0 154,0 0,255.5 0,271.5 	"
                      />
                      <polygon fill="#49803F" points="0,216.3 130.2,0 0,0 	" />
                      <polygon
                        fill="#A5A5A5"
                        points="245.5,0 177.9,0 87.3,150.4 154.9,150.4 	"
                      />
                      <polygon
                        fill="#49803F"
                        points="125.3,181.3 92.3,181.3 48.2,254.6 81.1,254.6 	"
                      />
                      <polygon
                        fill="#49803F"
                        points="793.6,377.1 773.5,377.1 746.5,421.8 766.6,421.8 	"
                      />
                    </g>
                    <g>
                      <g>
                        <polygon
                          fill="#F1CE55"
                          points="554.8,190 296.8,190 315.5,159.5 573.4,159.5 		"
                        />
                        <text
                          transform="matrix(1 0 0 1 356.0064 179.928)"
                          fill="#FFFFFF"
                          font-family="'Montserrat-SemiBold'"
                          font-size="18"
                        >
                          OF COMPLETION
                        </text>
                      </g>
                      <g>
                        <rect
                          x="234.6"
                          y="110.8"
                          fill="none"
                          width="401.1"
                          height="44.2"
                        />

                        <text
                          transform="matrix(1 0 0 1 256.3997 140.4328)"
                          fill="#49803F"
                          font-family="'Montserrat-ExtraBold'"
                          font-size="40"
                          letter-spacing="8"
                        >
                          Certificate
                        </text>
                      </g>
                    </g>
                    <rect
                      x="179.5"
                      y="230.6"
                      fill="none"
                      width="511.3"
                      height="30.5"
                    />
                    <text
                      transform="matrix(1 0 0 1 203.5715 241.3403)"
                      fill="#6EA060"
                      font-family="'Montserrat-Medium'"
                      font-size="14.4904"
                      letter-spacing="2"
                    >
                      This certificate is proudly presented to
                    </text>
                    <g>
                      <rect
                        x="209.7"
                        y="297"
                        fill="none"
                        width="455"
                        height="23.4"
                      />

                      <text
                        transform="matrix(1 0 0 1 256.3617 314.8501)"
                        fill="#49803F"
                        font-family="'Montserrat-ExtraBold'"
                        font-size="24"
                        letter-spacing="4"
                      >
                        {user?.studentname}
                      </text>
                      <rect
                        x="173.4"
                        y="353.1"
                        fill="none"
                        width="526.9"
                        height="23.4"
                      />

                      <text
                        transform="matrix(1 0 0 1 302.5826 363.5227)"
                        fill="#A5A5A5"
                        font-family="'Montserrat-ExtraBold'"
                        font-size="14"
                        letter-spacing="2"
                      >
                        {user?.coursename}
                      </text>

                      <line
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        fill="none"
                        stroke="#878787"
                        stroke-width="1.0145"
                        stroke-miterlimit="10"
                        x1="230.3"
                        y1="339.3"
                        x2="644.2"
                        y2="339.3"
                      />
                    </g>
                    <g>
                      <g>
                        <polygon
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          fill="#49803F"
                          points="451.4,477.1 414.8,477.1 414.8,565.3 433.4,551.1 
							451.4,565.3 		"
                        />
                      </g>
                      <g>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          fill="#2C2C47"
                          d="M451.4,528.7c-3.3,3.7-8.8,5-13.6,2.8c0,0,0,0,0,0
							c-3-1.4-6.4-1.4-9.4,0l0,0c-4.8,2.2-10.3,0.9-13.6-2.8v-54.1h36.7V528.7z"
                        />
                      </g>
                      <g>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          fill="#F1CE55"
                          d="M424.9,453.3c4.6-4.6,11.9-4.6,16.5,0l0,0
							c2.3,2.3,5.6,3.5,8.8,3.2h0c6.4-0.6,12.1,4.2,12.6,10.6v0c0.3,3.3,2,6.3,4.7,8.2c0,0,0,0,0,0c5.3,3.7,6.6,11,2.9,16.2h0
							c-1.9,2.7-2.5,6.1-1.6,9.3l0,0c1.7,6.2-2,12.6-8.2,14.3c0,0,0,0,0,0c-3.2,0.9-5.8,3.1-7.2,6.1v0c-2.7,5.8-9.7,8.4-15.5,5.6
							c0,0,0,0,0,0c-3-1.4-6.4-1.4-9.4,0h0c-5.8,2.7-12.8,0.2-15.5-5.6v0c-1.4-3-4-5.2-7.2-6.1c0,0,0,0,0,0c-6.2-1.7-9.9-8.1-8.2-14.3
							c0,0,0,0,0,0c0.9-3.2,0.3-6.6-1.6-9.3c0,0,0,0,0,0c-3.7-5.3-2.4-12.5,2.9-16.2l0,0c2.7-1.9,4.4-4.9,4.7-8.2v0
							c0.6-6.4,6.2-11.2,12.6-10.6h0C419.3,456.8,422.5,455.7,424.9,453.3L424.9,453.3z"
                        />
                      </g>
                      <g>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          fill="#E0A043"
                          d="M433.1,461c15.4,0,27.9,12.5,27.9,27.9
							c0,15.4-12.5,27.9-27.9,27.9c-15.4,0-27.9-12.5-27.9-27.9C405.2,473.5,417.7,461,433.1,461z"
                        />
                      </g>
                      <g>
                        <path
                          fill="#FFFFFF"
                          d="M433.1,517.9c-16,0-29-13-29-29c0-16,13-29,29-29c16,0,29,13,29,29C462.2,504.9,449.1,517.9,433.1,517.9z
							M433.1,462.1c-14.8,0-26.8,12-26.8,26.8c0,14.8,12,26.8,26.8,26.8s26.8-12,26.8-26.8C459.9,474.1,447.9,462.1,433.1,462.1z"
                        />
                      </g>
                      <g>
                        <polygon
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          fill="#F1CE55"
                          points="433.9,473.2 439.1,482.9 449.9,484.8 442.3,492.7 
							443.8,503.6 433.9,498.8 424.1,503.6 425.5,492.7 418,484.8 428.7,482.9 		"
                        />
                      </g>
                    </g>
                    <g>
                      <rect
                        x="199.4"
                        y="512.3"
                        fill="none"
                        width="178.3"
                        height="15"
                      />

                      <text
                        transform="matrix(1 0 0 1 230.4745 518.9971)"
                        fill="#2C2C47"
                        font-family="'Montserrat-Bold'"
                        font-size="9"
                        letter-spacing="1"
                      >
                        Date of Completion
                      </text>
                      <text
                        transform="matrix(1 0 0 1 229.7 494.4)"
                        fill="#2C2C47"
                        font-family="'Montserrat-Bold'"
                        font-size="11"
                        letter-spacing="1"
                      >
                        {user?.dateofc}
                      </text>
                      <text
                        transform="matrix(1 0 0 1 518.7 494.4)"
                        fill="#2C2C47"
                        font-family="'Montserrat-Bold'"
                        font-size="11"
                        letter-spacing="1"
                      >
                        Doyenify Academy
                      </text>
                      <line
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        fill="none"
                        stroke="#2C2C47"
                        stroke-miterlimit="10"
                        x1="220.4"
                        y1="501.5"
                        x2="353.5"
                        y2="501.5"
                      />
                    </g>
                    <g>
                      <g>
                        <line
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          fill="none"
                          stroke="#2C2C47"
                          stroke-miterlimit="10"
                          x1="505.8"
                          y1="501.5"
                          x2="638.9"
                          y2="501.5"
                        />
                      </g>
                      <rect
                        x="506.1"
                        y="512.9"
                        fill="none"
                        width="132.1"
                        height="26.8"
                      />
                      <rect
                        x="503.1"
                        y="510.7"
                        fill="none"
                        width="141.1"
                        height="11.5"
                      />

                      <text
                        transform="matrix(1 0 0 1 553.8239 517.363)"
                        fill="#2C2C47"
                        font-family="'Montserrat-Bold'"
                        font-size="9"
                        letter-spacing="1"
                      >
                        Issuer
                      </text>
                    </g>
                    <image
                      overflow="visible"
                      width="308"
                      height="84"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATQAAABUCAYAAAAMAstxAAAACXBIWXMAAAsTAAALEwEAmpwYAABC
				82lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0w
				TXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRh
				LyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS41LWMwMTQgNzkuMTUxNDgxLCAyMDEzLzAzLzEz
				LTEyOjA5OjE1ICAgICAgICAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMu
				b3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJk
				ZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFw
				LzEuMC8iCiAgICAgICAgICAgIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMv
				MS4xLyIKICAgICAgICAgICAgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bo
				b3Rvc2hvcC8xLjAvIgogICAgICAgICAgICB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNv
				bS94YXAvMS4wL21tLyIKICAgICAgICAgICAgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5j
				b20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIKICAgICAgICAgICAgeG1sbnM6c3RSZWY9
				Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiCiAgICAgICAg
				ICAgIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIgogICAgICAgICAg
				ICB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyI+CiAgICAgICAgIDx4
				bXA6Q3JlYXRvclRvb2w+QWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKTwveG1wOkNyZWF0b3JU
				b29sPgogICAgICAgICA8eG1wOkNyZWF0ZURhdGU+MjAyMi0wOC0xOFQxNTo0NDozMiswMTowMDwv
				eG1wOkNyZWF0ZURhdGU+CiAgICAgICAgIDx4bXA6TW9kaWZ5RGF0ZT4yMDIyLTA4LTE4VDE1OjQ5
				OjI3KzAxOjAwPC94bXA6TW9kaWZ5RGF0ZT4KICAgICAgICAgPHhtcDpNZXRhZGF0YURhdGU+MjAy
				Mi0wOC0xOFQxNTo0OToyNyswMTowMDwveG1wOk1ldGFkYXRhRGF0ZT4KICAgICAgICAgPGRjOmZv
				cm1hdD5pbWFnZS9wbmc8L2RjOmZvcm1hdD4KICAgICAgICAgPHBob3Rvc2hvcDpDb2xvck1vZGU+
				MzwvcGhvdG9zaG9wOkNvbG9yTW9kZT4KICAgICAgICAgPHBob3Rvc2hvcDpUZXh0TGF5ZXJzPgog
				ICAgICAgICAgICA8cmRmOkJhZz4KICAgICAgICAgICAgICAgPHJkZjpsaSByZGY6cGFyc2VUeXBl
				PSJSZXNvdXJjZSI+CiAgICAgICAgICAgICAgICAgIDxwaG90b3Nob3A6TGF5ZXJOYW1lPkxheWVy
				IDE8L3Bob3Rvc2hvcDpMYXllck5hbWU+CiAgICAgICAgICAgICAgICAgIDxwaG90b3Nob3A6TGF5
				ZXJUZXh0Lz4KICAgICAgICAgICAgICAgPC9yZGY6bGk+CiAgICAgICAgICAgIDwvcmRmOkJhZz4K
				ICAgICAgICAgPC9waG90b3Nob3A6VGV4dExheWVycz4KICAgICAgICAgPHhtcE1NOkluc3RhbmNl
				SUQ+eG1wLmlpZDo5ZWJiMWEzMi1hMDFmLTM1NDItYTVmMS1iMzJkNmI3ZmY0ZTI8L3htcE1NOklu
				c3RhbmNlSUQ+CiAgICAgICAgIDx4bXBNTTpEb2N1bWVudElEPnhtcC5kaWQ6ZDY0MmYxMTAtYTA4
				ZS0zOTRiLWE5YzAtMjU3ZTE0YzcyMjFmPC94bXBNTTpEb2N1bWVudElEPgogICAgICAgICA8eG1w
				TU06T3JpZ2luYWxEb2N1bWVudElEPnhtcC5kaWQ6ZDY0MmYxMTAtYTA4ZS0zOTRiLWE5YzAtMjU3
				ZTE0YzcyMjFmPC94bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ+CiAgICAgICAgIDx4bXBNTTpIaXN0
				b3J5PgogICAgICAgICAgICA8cmRmOlNlcT4KICAgICAgICAgICAgICAgPHJkZjpsaSByZGY6cGFy
				c2VUeXBlPSJSZXNvdXJjZSI+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDphY3Rpb24+Y3JlYXRl
				ZDwvc3RFdnQ6YWN0aW9uPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6aW5zdGFuY2VJRD54bXAu
				aWlkOmQ2NDJmMTEwLWEwOGUtMzk0Yi1hOWMwLTI1N2UxNGM3MjIxZjwvc3RFdnQ6aW5zdGFuY2VJ
				RD4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OndoZW4+MjAyMi0wOC0xOFQxNTo0NDozMiswMTow
				MDwvc3RFdnQ6d2hlbj4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OnNvZnR3YXJlQWdlbnQ+QWRv
				YmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKTwvc3RFdnQ6c29mdHdhcmVBZ2VudD4KICAgICAgICAg
				ICAgICAgPC9yZGY6bGk+CiAgICAgICAgICAgICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVz
				b3VyY2UiPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6YWN0aW9uPmNvbnZlcnRlZDwvc3RFdnQ6
				YWN0aW9uPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6cGFyYW1ldGVycz5mcm9tIGltYWdlL3Bu
				ZyB0byBhcHBsaWNhdGlvbi92bmQuYWRvYmUucGhvdG9zaG9wPC9zdEV2dDpwYXJhbWV0ZXJzPgog
				ICAgICAgICAgICAgICA8L3JkZjpsaT4KICAgICAgICAgICAgICAgPHJkZjpsaSByZGY6cGFyc2VU
				eXBlPSJSZXNvdXJjZSI+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDphY3Rpb24+c2F2ZWQ8L3N0
				RXZ0OmFjdGlvbj4KICAgICAgICAgICAgICAgICAgPHN0RXZ0Omluc3RhbmNlSUQ+eG1wLmlpZDpi
				Njg2OWJhYi01ZjAwLWJiNGItYjdmYS1lZTlkNzE5YTY1YzI8L3N0RXZ0Omluc3RhbmNlSUQ+CiAg
				ICAgICAgICAgICAgICAgIDxzdEV2dDp3aGVuPjIwMjItMDgtMThUMTU6NDc6MTQrMDE6MDA8L3N0
				RXZ0OndoZW4+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDpzb2Z0d2FyZUFnZW50PkFkb2JlIFBo
				b3Rvc2hvcCBDQyAoV2luZG93cyk8L3N0RXZ0OnNvZnR3YXJlQWdlbnQ+CiAgICAgICAgICAgICAg
				ICAgIDxzdEV2dDpjaGFuZ2VkPi88L3N0RXZ0OmNoYW5nZWQ+CiAgICAgICAgICAgICAgIDwvcmRm
				OmxpPgogICAgICAgICAgICAgICA8cmRmOmxpIHJkZjpwYXJzZVR5cGU9IlJlc291cmNlIj4KICAg
				ICAgICAgICAgICAgICAgPHN0RXZ0OmFjdGlvbj5zYXZlZDwvc3RFdnQ6YWN0aW9uPgogICAgICAg
				ICAgICAgICAgICA8c3RFdnQ6aW5zdGFuY2VJRD54bXAuaWlkOmVjMjlkYWVlLWU4ZmQtNTM0Mi04
				NmI5LTRjOWMzN2RmMzc3Zjwvc3RFdnQ6aW5zdGFuY2VJRD4KICAgICAgICAgICAgICAgICAgPHN0
				RXZ0OndoZW4+MjAyMi0wOC0xOFQxNTo0OToyNyswMTowMDwvc3RFdnQ6d2hlbj4KICAgICAgICAg
				ICAgICAgICAgPHN0RXZ0OnNvZnR3YXJlQWdlbnQ+QWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dz
				KTwvc3RFdnQ6c29mdHdhcmVBZ2VudD4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OmNoYW5nZWQ+
				Lzwvc3RFdnQ6Y2hhbmdlZD4KICAgICAgICAgICAgICAgPC9yZGY6bGk+CiAgICAgICAgICAgICAg
				IDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVzb3VyY2UiPgogICAgICAgICAgICAgICAgICA8c3RF
				dnQ6YWN0aW9uPmNvbnZlcnRlZDwvc3RFdnQ6YWN0aW9uPgogICAgICAgICAgICAgICAgICA8c3RF
				dnQ6cGFyYW1ldGVycz5mcm9tIGFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5waG90b3Nob3AgdG8gaW1h
				Z2UvcG5nPC9zdEV2dDpwYXJhbWV0ZXJzPgogICAgICAgICAgICAgICA8L3JkZjpsaT4KICAgICAg
				ICAgICAgICAgPHJkZjpsaSByZGY6cGFyc2VUeXBlPSJSZXNvdXJjZSI+CiAgICAgICAgICAgICAg
				ICAgIDxzdEV2dDphY3Rpb24+ZGVyaXZlZDwvc3RFdnQ6YWN0aW9uPgogICAgICAgICAgICAgICAg
				ICA8c3RFdnQ6cGFyYW1ldGVycz5jb252ZXJ0ZWQgZnJvbSBhcHBsaWNhdGlvbi92bmQuYWRvYmUu
				cGhvdG9zaG9wIHRvIGltYWdlL3BuZzwvc3RFdnQ6cGFyYW1ldGVycz4KICAgICAgICAgICAgICAg
				PC9yZGY6bGk+CiAgICAgICAgICAgICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVzb3VyY2Ui
				PgogICAgICAgICAgICAgICAgICA8c3RFdnQ6YWN0aW9uPnNhdmVkPC9zdEV2dDphY3Rpb24+CiAg
				ICAgICAgICAgICAgICAgIDxzdEV2dDppbnN0YW5jZUlEPnhtcC5paWQ6OWViYjFhMzItYTAxZi0z
				NTQyLWE1ZjEtYjMyZDZiN2ZmNGUyPC9zdEV2dDppbnN0YW5jZUlEPgogICAgICAgICAgICAgICAg
				ICA8c3RFdnQ6d2hlbj4yMDIyLTA4LTE4VDE1OjQ5OjI3KzAxOjAwPC9zdEV2dDp3aGVuPgogICAg
				ICAgICAgICAgICAgICA8c3RFdnQ6c29mdHdhcmVBZ2VudD5BZG9iZSBQaG90b3Nob3AgQ0MgKFdp
				bmRvd3MpPC9zdEV2dDpzb2Z0d2FyZUFnZW50PgogICAgICAgICAgICAgICAgICA8c3RFdnQ6Y2hh
				bmdlZD4vPC9zdEV2dDpjaGFuZ2VkPgogICAgICAgICAgICAgICA8L3JkZjpsaT4KICAgICAgICAg
				ICAgPC9yZGY6U2VxPgogICAgICAgICA8L3htcE1NOkhpc3Rvcnk+CiAgICAgICAgIDx4bXBNTTpE
				ZXJpdmVkRnJvbSByZGY6cGFyc2VUeXBlPSJSZXNvdXJjZSI+CiAgICAgICAgICAgIDxzdFJlZjpp
				bnN0YW5jZUlEPnhtcC5paWQ6ZWMyOWRhZWUtZThmZC01MzQyLTg2YjktNGM5YzM3ZGYzNzdmPC9z
				dFJlZjppbnN0YW5jZUlEPgogICAgICAgICAgICA8c3RSZWY6ZG9jdW1lbnRJRD54bXAuZGlkOmQ2
				NDJmMTEwLWEwOGUtMzk0Yi1hOWMwLTI1N2UxNGM3MjIxZjwvc3RSZWY6ZG9jdW1lbnRJRD4KICAg
				ICAgICAgICAgPHN0UmVmOm9yaWdpbmFsRG9jdW1lbnRJRD54bXAuZGlkOmQ2NDJmMTEwLWEwOGUt
				Mzk0Yi1hOWMwLTI1N2UxNGM3MjIxZjwvc3RSZWY6b3JpZ2luYWxEb2N1bWVudElEPgogICAgICAg
				ICA8L3htcE1NOkRlcml2ZWRGcm9tPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZm
				Ok9yaWVudGF0aW9uPgogICAgICAgICA8dGlmZjpYUmVzb2x1dGlvbj43MjAwMDAvMTAwMDA8L3Rp
				ZmY6WFJlc29sdXRpb24+CiAgICAgICAgIDx0aWZmOllSZXNvbHV0aW9uPjcyMDAwMC8xMDAwMDwv
				dGlmZjpZUmVzb2x1dGlvbj4KICAgICAgICAgPHRpZmY6UmVzb2x1dGlvblVuaXQ+MjwvdGlmZjpS
				ZXNvbHV0aW9uVW5pdD4KICAgICAgICAgPGV4aWY6Q29sb3JTcGFjZT42NTUzNTwvZXhpZjpDb2xv
				clNwYWNlPgogICAgICAgICA8ZXhpZjpQaXhlbFhEaW1lbnNpb24+MzA4PC9leGlmOlBpeGVsWERp
				bWVuc2lvbj4KICAgICAgICAgPGV4aWY6UGl4ZWxZRGltZW5zaW9uPjg0PC9leGlmOlBpeGVsWURp
				bWVuc2lvbj4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1l
				dGE+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAK
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				IAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAog
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAK
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				IAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAog
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAg
				ICAgICAgICAgICAgICAgICAgICAgICAgCjw/eHBhY2tldCBlbmQ9InciPz779IBeAAAAIGNIUk0A
				AHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAFiHSURBVHja7J13vGVVef6/q+xy
				yi3TaCJVUAFFRREFRTRGo7GgKNZojCn2Envvxp4YjCVR0ICiAtbYRUEEERsGBEE6TJ9bT9t7r7Xe
				3x9rn3PvwDSGEQi/+/q5nxnGmXPW2WetZ73leZ9XsWRLtmT/39mHf3KarN60jquuv5rV69fSr/rY
				LKHVatFMGhz7gIfylr94gfq/9rnu0AW/6Qsfkwsu+TXJRIv2igmm5maZn58nSRIym9DrdMmSlIZN
				GbM5DzrkcN74pBeqpe24ZEu2c/Z3n3+X/PzXv6BT9uhVfQa+RCeGrJVjUkvlHK5fYkshDZpVEyu4
				z8GH8qUXf+j/xLmzd+Sb/+A3P+WSjdeSVGMUUx7RikaSMpjrYa1FCajCkGMZrJ/FZ7K0I5dsyXbC
				3vjD/5D/+dmP+MJPz6S1cgxaCpVkNE0DQQhAJZ4gIOMJlQR8gGu667n6dzdxwKv/Qh562IM49QXv
				v1MD2x0KaKqVktCEFRlOCgTBGSCxVCIopQHQonAtTWjopZ25ZHdpe93Z/yEzM9OkzrPb2CS7jS3j
				n4557m0CkZef+QH5xjnf5Ya5DYRJS9mCftVDo7BolFIEgaBAFIgKmEyjBSpXsdvkCvxAceZ3vsGj
				3vZ8+fG7TrnTgtodCmgiQpqmkKb0qwofPCKC1hrvHSAopWDJMVuyu7B99Eeflx9feC6XXn8l//G5
				T1H5inaSsqI1zvLWGK8+7Z3y0We/fadA5HVf+6ic9eP/4drZtYztvZJmljFf9aD2wAIBrTWCIow8
				DSH0+ygMeCExCeIcqbbcfY+73amf5R3q8hTFAO89VVXhqgpxjqIocK4ihFD/eIKE0X8v2ZLdlezv
				P/kW+fIPvsHvr/8jVRoY32OSyb2WY5bl9HPhhu4mvnfRuRz/4b+/1df62777Cfn+z89m9ewG2qsm
				aS8fRxINBDAKtEK0qj0zBcMfUYBBCkcrb+GLinU3ruFeBx7MKS9+75065LxDAS2EgIjgnIPgwWpE
				ImgppVCK2ksDhUKxFHIu2V3LLrzq91w7v45+HgjjFp9DYR1qWU7RVrjlGevp8rMrfscLT3/HrQK1
				Cy7/DddsugkznmPHc2aLDt2yh23nkBiwOoIaqj5vGqUMYLA6Q0vCeDZGIgmZSrjn/gfd6Z/nHYoQ
				QkApFUFMKaw1KB0vCZQgsvj7U9zBRdklW7Jdasd/6p/lhu5GernQzzzTbp5O6OEzYWN/mvW9KeZ0
				QTVm2Rg6nPu/F/GG735ih0DtWZ97jfz+2j8ySALJZIOQwCCUSKhwrgJdn6VATOkEMEGjvcIGjakU
				4/kYZadgbsM0973nYXzhH95/pz+Adyigee9jjgygBq/gPShqTy2C2uKfJVuyu4K99Yf/KZdefyVz
				qsC1DXZlCz2ZExqaHgV2PCNfOU6VgWsakpVjXLnuen78i3N36PV/fslvWNebwoxnSKbp+wJliJ5Z
				OYjnTRQE0B6s19igSYMm84aGZLRVAz9f4uZL7nvwof8nnusd66HVBYAhqIkI1GGo1hptdPx10c+S
				Ldldwf5w1R+5fv1qTDvHp4rZQYfe3BT9qodYKLrzqFTjqgHdoktj2RhiFTeuXb3d1377T/5Tpqt5
				9FhKe+UEIYH+3HR8TQUqy9Gi0AGMVyTekHpD01taPqHlExre4mYGTCZt7rXvPfiPZ7zp/0R4dIci
				xOJq5tAbU9aO/tx7F4sCNcgteWhLdlex9Rs2oKwha+Z4JWANtJqgQCcW02xS9AdgDChFmqbYJNmh
				1/7BBecgucE0E2Z7c3QHXXSrAYmFIOgAzSSnoTPSYGhKSl4ZivXzmFkPUwXF+g5ZZQjzJUfd54H/
				Z56rvXMuawm4luyubRpNKB2JMqTa0i/68TSmGa5fQIA0b1B6DyFgRaODoML2z8aamQ04IwQtKBUI
				tcOgUWg0BkNvvsd41mZ2Zg6rhcMOOoy977MHk/kY4gJpI+P6a69j0+oNHLjHvkuAtuPAJTf7vSyB
				2pLd5e1uK3fH/lHw8wXtVS28qShDSZJYKnExt1UprNdkNiP1ClMExrMm2wo633nBF+SDp/w7rNSI
				EmTROVJKjwDNuYpWu0lJl8P2vzc/e+VntxpS/uxDX/o/dFHcqT20m4PaUpVzye4a9qBD78fu7eX0
				1k4jswXLs3EySaCCNG3STJpIKaRiaZJSTnfJg+Ggu+2zzdddt2kdDofomlNGnZtGoUShVYQ0gqY/
				18cGyxH3vt9dyPO909rNPbYlW7K7jr3q4c9QR9zjUPI+zF2/AdMT8pCiK01KTqIytNOkwVLO9pm7
				aSN7T+zG0fc7cpuvOz21kdSaSIeqW5riMY88M0QjomhkTUIFqyZWcdLjX3mX8RTuYECrwUrJDoal
				Sx7akt117LgHPpQjDjqMvFSU0z1MqUhJcYWnKjyJTrHBEHoVE2mbIw97AG943D9s8xBMbViPHXLM
				iF6a1L8XNEEUwQtl4ahKRyNp3KWe6R1fFFBLHtiS/f9pL37EieoT535FWuePcdnaa9nU65GkTXqD
				Aosi0RaN5u67350HHXQYn33ue7Z7o89NT2GGrIHNzplGBLwExMP42ARpqsnT/C71TO/Y1ielCCOv
				ayHEFCQmNJXUgBd/1FL4uWR3MXvJw5+u/uohj2Lf9h7kczDeT5gYJEwUKc2+pjkw3H+/Q/j8DoAZ
				QK8YEIyOJ0UEBAwKLTG+EQQvgUFZMOj36czOLXlou8oqawha40MAEazReA1eHKJDndMM6BBQBAxL
				zelLdtezlx779BFYve8bn5c169fQbObcba89eflxJ6pr+eGtOlNF0ASl0ChMELRE+oZXIFojBpI0
				YX7dRo57wAO4fAnQdo0Juu54WqjGiBo6y0JQgpKhpzZsOluyJbvr2pue9LzblihWBl8XBCAGOLo+
				Nnp0tmL/tEhABb8Ucu6yN5co3hixKjafB+ItMoxEZSg6RxSgW7IlW7JtnCmv0F6Nzk5U01iEdwyV
				bBRaqfh3lgBt15gJoENkMMOwxKxAxzIzipHwXFDglzy0JVuybUc9XgjOg6ihiAZS657JUIZLpAa2
				+qgthZy7xlQIaB2TliN5oBFDQ49KzoKKBYQlD23JlmzbZ4oatKIG11BQY6QWNPTXJDggEO5iLIM7
				FJ+VxISlQaOVRoLUgDaMNxnNFRi50Eu2ZEu2dQ9NgzF6FG4GFaObMDpWkS0QvEOUEPRdq9B2x8oH
				BUEJGKUxyqCVjqXmOqdW6zyi6vyaWkK0JVuybVpIBLGLAW4osS21QyBoBSH4ePqTu9aZumMBrXZ3
				tVrgygzdMFUXDLQsVGr07QBonzjvy/KJ8768lKxbspF9/LyvyL/+H9kThXYEE0Zna3jAhqAWMS3K
				2mur6hkDd62Q+1bZO7/7CfnT9Vdz5XXX0HcFvbLPoCwIEqgfF0pgeXuCA/bel/sefB/e/biXbPF9
				Dn7tY+WmzgbG9lrO2tmNkBlMluJDBb7EaI1RCXnIKNbM8+jDH8a3X/rvtxnV3vzjT8rVq69n48w0
				a9evY2ZmhnJQxGTpsBtLadI0pdlo0cwajLfGuPtee/P5v33XrX7/k848WV761L9Vnzrny/JPx56o
				/vX80+SVD332Nl/nI9//gvzzY/7mz4LgH/jZqfL6hz1HAXzkF6fLPx/1jM3e50Pnf0Ve+9Cnq4+f
				8xWRbskrHvecW7WO137zY3LOb89jvuzR6XUpynKh4IMCL2iBPZavYvfJlawaX8bB++7POx7/0tv0
				eU/6yany0uPiWj/2i9PkVUdt/Rl/4tyvykse/rQt/v9v++Z/yvm//wXT/Vlm5mbp9Xt4CSitaeQ5
				eZqTKsshBx7M6S+6bQN4//3cr8nLHn786DX+7YIvyise8qz6M/y3vOqorY+w++hP/ltefdzC//+s
				r79Jfvyb8xlYoSMlXoVRTlorai00QTkhNxm2gkP2PZiH3udBfOiYF6v/rwDtJV98p1x65WXcuHEN
				s/0OPV8QNIjVmNRikwRdM5RVgKZNKeYGFLN99ly+J8c95Fg+/ezNVS/v/fYnyVXrrmVyzxVM9+cI
				VqESgw8eQlmHoil5SCnXzPOXhz+Mb7xs5wHt+I+/WC655gpmyy6VAUdAFGhjsMZgtImAFgStDcEH
				XOWpBgVVUWExrGhPsnJ8OQfstS8Pvu8DeM2xz9zuel74/lfLuRedT768hU8VnaqHN4IbcesErRRG
				abRS2JCg+5pjH/gw/usl794lG+293ztFvv3TH7B2bgMDXyA6hh+IoNAopRGl8EFQAcaTJvNrN3Hg
				Hnfn5584Y7treMeP/1N+9svzueyqP7KhM83Y3ZdTqGp00WldN0z7mFLIdILvl1A6UtE0dcIeK1Zx
				5AMeyEknvPVWf+bnf/jVcsGlvyaZbDBXdKmqCmstQcA5hwhYbcELrqg44r4P4Luv/9Rm7/P8z71L
				Lr/iCtbMrKOjelTGYxKLTWzc2yGgUBg0VjTdTbNIv+SAPffh2COP5iMnvv5WrfsFH3+n/Ox3v8Al
				noEf4KUi9s4ElBJ8CIg2TOZt7FzJPffcj69/4DQF8JYzPyZn/fg7dHXFgJLmZIM+FWun1qIm2ug8
				ZYFhVg8aChJJ6k5w/QrpV7TSFssbE9iep+EMh+57EPc74N60fUrqNa6o0KJppg0MGl9GaaMsTWk0
				GvgQ6Pa7LF+5gic88Ym7DBTPPPPMutlBNhN4XSz0aozZTPRVKbX9Kucbvvtvct6FP+eL3z2L2aKD
				aaXYZsbEylVUeMrg8RIoAFVzXrRAEIeZTEiaKZuKLmed+z3u/Ybj5eEPfzifftyrFEBlhTJUFK5E
				WxMDYAGtFF4WtzzFP9M72Zx+4kkvkd9ecSk/ufjnhNxi2zml8nijUVrjFJQhEIKLB1yDVQZtNEkz
				IZ/MSV2gGpRsKnrMbOpy0/RaLv7j/3LiSa+RL7/0w9tc2KEPOJzvXHg2ojPILD4zFFR4LaDjJ4yf
				DwzgBXrdDhdft+s43Of89gL+NHUDc75H0spIsiRKnYsa8ZIEhUdhvKI7KOn4gt332fYcxnf98D/l
				wkt/w398+XOsn5+iMdYgvds4nczhLGgdFYhF1VQcH1BBKEUwWUIiGbjAfL9gdup6rvvpGu71qkfK
				I+7zED71gh0fmbZ2foq13Sla48uZDT3SRoIxEnNIwQAKjyZUnkoJRXvhpd9+0aly3gUX8D+/+DGl
				d6impcoV3iq0AWcFkXrUog+YoJhotUlNk2JO+MPaP3Htt6/n6LeeIA898sF86Amv3aF1r+9McePs
				erLlTSQTkkZGkmiKQY+o/qOofGAuFIRynr0YjP7tjO+wsZqjamgKVdGvPLaZ0N5zBRMrVrBu/cbY
				6jQkDyhQakGWa7c9VqGCQryi6DvmfY9uCdNVhzIRWhNj5N5SDUp84UlMSqoTdKZQAt1Ol06nCwrK
				smJqatMu9bRmZmbQWmOMuYVMv4jgvSdNU7TWDAYDiqJgcnJy24B24udfK1/8zpnM9uZJV7ZYmU3E
				LzfRlKmiClB6oXK+VsVUcRFAvyhopjnj4xNkOmduwyyXr72GuXML/vqrb5IDDj6A0888HSxU4kYM
				5uEDR6m6fWOUcLvVfewvOfOd8rMLz+esc76D5JaVd9+TbKJFL5SkWqgIOO9xPhCGFVaJ71nMd8AY
				UpWR5w2SRkrStITCEwrHoPAUxRw//NW5HP7qJ8qjHvowPnrCljfyqx7zPPW497xA/nDDlQQdCKlG
				jEWMEJ+cLAC20igx6BVNNro5/uJ9fys/etPJt/nmu3LddciYZWJiN0gVvX4HJQqpLxCINJkgYJxC
				KuHAAw/grNf/21bf+xn//mr57Fmnsr4/Q5UIKw7YncmVk/RDydrOJoJViIq9gyJ+dFkZE5nqXgnO
				e5JMk7faGIHO/DxTm1Yz/fMfcPy/vlgecv8H87pjt8+eT8YajO+xksl9d8fPbYoKsEajzIJ0jkKj
				ncc2DYM0+i8v/+Wn5EvfPZMbVq/G5gnNsTEkUwRTUvmCoorpD5SgDBirMUoz67pMjLWZnFxFf6LB
				7Pppfnv9ZdzUWc8x736GnPfW07ffSD7oYMdylu29Gz3p4ZQjJJpKa0x9iL0P+GBQ7QzVTEf/tusL
				+jgak8vQKQyKLkU1oKj69MoCa7LYjL7o0NQ9AoCwcWoj1iQE0aQ6IZtsID3Put40l1/3J7K7aZbZ
				du2ceLTXaIlToQyayclJup0uebPBsmw507NTnP7lL8ozTnzWLvHSsiwbAdrNQQ3iCMwo1e/RWjMx
				McGJJ56otgpox3zwb+WnF/+STd1pGuMt9EQTpwIDXxLwDGZm41w/Y1BGx8MRhFDFOQAYoev7dDfO
				AykrJnZjrxX7MTczx7d/9F0O23Qf5oouupUjRuFcGAFKqMfaiVYEUYiom2sHbNfu87q/kjPO+S6F
				L1lxj72xzYxuNWDdpjVIqCDPYmJBG5SJYUUIAV85gnM0l40TvKNynvnBPKo0pElKkiXYNKE0nmUr
				l+Hm+1yx7jrWfG89f/Wv/yjffeWnt/iFfuctn1MHvPQ46boSMkOBpwqeCo/UXqjRug5nArphmR30
				+fWVv+cdP/qUvOMv/mmnN8oTT3ql/PQPF+LaBmM08525iF8hehsGjVF2RGIWZyimujzimAdy8VZe
				84GvOV5+/LvzcS3N8r32JFihomLd7Do6U5vQyybjWLSauSlxlBdGazRxZGF3vkMoClCGea1RAnkj
				Z+VBd6ecGfDjyy7i99f9iZee8UE56YTXbfPzz/U6dKo+DDps7M2QZimVcoQgo8sWUYjzEDxXrbuG
				+33mufLV757FmjVrSBsNvHH0yxmyNEe0iiEfIXK9jUEhOO+oXICyol/2yWxKblJad1tOqDwb+z02
				3HAFx7znefLU457Aq44+YavrNlmMACRTzM51GVRdslZGKQU6xDPlfMCTkCpBEjP6t2PLlqESSyE+
				er+pJdVR7TYUFTrPENg87CRe2gow1uAJOF/hNKTNHIxhthhw3cbV7L9qb9pJkzxNwYMPQhU8JqgY
				eoui3+ujteb4pz9FnfaFL8j01PQu8c5OPfVUGYJWCIGqqm5ZUBRBKUVZllRVxcTEBLAVYu1TP/lG
				OfuS8/BNRWv3FRS+ZN38NBiFzhOsTdDtVj1oufacRGqSvwIdwHqsNVSpp+xWzAzmSF2JWCFZ1uby
				a68EI6SNnKBjOi/IUHsj1FOdoxid1KznHYk43//dz8uX/uerXD29Gr0spT2+AjGK2aJHt+ohiSbJ
				x6mCr6+s2pUNEmkhdQ5t0O+iiHIrBEGCYoCnCCVKFI1WzqzromygfbflVN2Cc37/Cx7wnhPkCUc/
				hnce9/e3WO0+++7HZWuuou8qQq7wWhGUHgFafIDxd41WTt/NMzbZ4Ke//Nlt2iC/u/z3kBukoQkZ
				kaxEQAWFqqv3SgSjFF4g8Yply5Zz5OH35+biyx8754ty8hmnccP8Bqq2JVvZwjUUM/PTFGUPaxV2
				vBkr1D7KPSsg+ICEgIhDgEEoSJMEk+fxkYeAC56BOPrdaRrtFpUYbpjbxPcvPIfXfv3j8qEnv3yr
				O2BQFhSuJBUHqSFYIUjU0w8iNZ8xphMwivmqS++mq+l1eqiGxrYthavw3pHYDG00ykU9MbXwtaB1
				zHKpRopRGtGafnD0xaGswk7mNCcyfnn579ht2aptfi9ePL2ihy17lFKBFcgM2iSIB20sFo2uNBUF
				3UF/UfY7vrcToSxLgivJUkNiUrI8xZWxr0bJAn9zcQyU5RkOcMGDtgyUx6oI3lP9eTbNz7A8H6eR
				N9BOCGUgAEmdbyZAnucE7znzS1+RKlQ0GrtGW817T5ZlWxxfOUyPDD0zrTXNZpMnPelJaou0jb/7
				7PvlV5f8nj4enxpUM0c3G9hWE9tqgrWUzhEkDjv3pccVjlB4bNA0bcZ43qIa9OkPOvjgSBopOtH0
				qz4ljtbyMZxUqMzgVKD0FdpqlFHxrFkzGlU/JAbG+2X7iHbB737F2vkpQitB2hlzUrJmbor53jw6
				T2m023GjGIsxJoKYC0gVb59W1mJibJLcJjSzlLFWi7zdJGk1MHmCGCFIQS8MKI1nPvSZcV2S5U3G
				9lrO1Rtv5NSzTt/i2h7x8EcwPj7BfKdL6RwuhNicP1QXBSrn6VclU51p+qFANSxrpzfy4Z+evFO0
				geef/BbZOLsJSRWkmm6/A6kGFQh4BA/iUeLAO1RwKFfxyIcew6seeuItHvi3zv4+V6+/CddK8C3L
				tOuybnodRTEHNpDnhsl2E1sF7MCjOiWqU6J7FWYQSCohceC6A1y/pCpKnHOYNKE1PkbSyAnK0XUd
				WNmitfcKVnc28r1zf8SHf3CqbAsc0IoqeEQJhSuoXIH3JYJHdIgXrRF0ouiXPZxUtCdbNCeaqASy
				VorKDf1Bh36nixuUKCfoGHCQKE0jyxkfGyNJEoKCwhUUoaTQgSpVDBKhbwLJZJPfXXEprzrjI1td
				83CwtiAkaQJpgifg60lnlRfQlrTRJEkzFg89m5ubx/uA0gatLaCoCofrl2hf90hvwQcYzhkYFPEC
				0FmCziyFOAZ4ShWYL3v86dqrWb9pA4OqwKtQ91RHLpuq0b3VaqG1ptePQGuN4fP/fbJ8/Ztn7TTF
				5Stf+YpYa0fgtTjstNaOfpIkQWtNkiQ897kLld7NAO3VZ/67/PQ357O2s5H2inEqqZjtzlL4AmUV
				omvlC63R2mBMQprkpDaLgxeKiu5ch5mN04T5ARSC8oL4QNbIGF8+gU41M5vWY1o5OjG4skBchdIa
				YyxGx4WPSvxKL9ws25h48+Hzviz7v/BR8j8X/JB8zwkay8fpVgWdXpckz2gsmwSj6fd7FL0ernLg
				hMRr0kqh+x7XKSg7A8pegXKKUAQGnQGDTp9qUBBC9BxJLSKeSnkkAZVrnA3MVT06oU9oKI552VNu
				sdh3PPh56pC735Pl2TJUodFOY8RglMFqWyfmAQmYNKG9fJyNvRk2DGb4/oU/3akN8pMLf07IDfl4
				k9Z4C/pd8LH4oSWqmVCLmWgPSaVIS8V/PuvttwCzo97wNDn7V+cytv9uyESCGk8JVsAqsvYYk60x
				VCn0N3VYoVusCE2W+wbLXYM9GGffbBUHje3NvZbvx/7tPWkMDGG2IpMUvGJ2epbBYEC6bBnJymWU
				VZcuBTJmuWLtNXzjJ9/e6ue0WpNlKSAx5TH8UErQWqHr3JEXT0UgbTUoJVBWFcEFpPRkYmnbBm3d
				IC8145KzLGkzmbSxlaGYL+hsmmV2wxRKa7Q1qNSiMovODGLA+YpO0WVyzxVcvfoqzvvfX26dBGo1
				GIUTT6hD22G6RecpKMGVBb6qaob5opwhBis2ynSTMNmYZLwxjhdNpygIowEpw0r2wj8PGsRoQhBM
				UKRBYyshE4O1KS7AmvXrmZmfpwoBbRO0tSitCfUzGxSDCDg2gk2axRB3MBjQHxQ77Z1NTU3dIl82
				rHRWVUVRFPT7fUIIFEWBc27zZ7r4P7768++wXs9iV2aUMsAawZqASEHl+gQpUTqgtKCNwQ0KiqIk
				TTNa7THa7TZ5nmGVIU8m0ANL4lNaaRNflMzPzeBCAc0EHyqKsoAkAZtQDap6Ho3BzfdjDqHel1ob
				Em22WcH45jnfpN8qaBw4zgZmmOrOkGhDZlOkqKgGBc77mPfLU5QxKAd5CcvIWZWMsSJp0zA5mW2S
				6RatZIJWOk5mGmgSpArgwSQZOktiVVQHxEAlFWkzoT3RppeU/HrmDzzkLcffAtS+8XcfVgeO7ceY
				b5EWCU1JoV8hRRmJxVVJkuX4ThdXDEgmG8xmFRetvoyXfPv9t+rme8EX3yMbqg6hleITxczsNChF
				UnroDpjIm1RlFS8m0yQNGYM1XY6779G3eK3HnfQSuWjN5diDVlKs0MyYLl3p4qo+2gvjtkFWJYR5
				D7MBWTfgoObdeObRf811HzlH/emDP1aXvvs76jdv/pq66LVfUf/02L/h8Yc/ir2zPSg3FPSmCtAN
				yNuUTnDdPjhPqUqylU3SVRlXTl3NCR9/8RafwaDfRcSjVUDXIGa0IcOQesG6yMGKzcOaQgSdNVCk
				pCGjUWb0b5ije/UMyaZAtqlij9CiunGO/k1z5FXGRLaMlSvvBiZjUFQ48SijQAnBOaRy0ZsDuqFL
				sucYv73hMp73lXducc1eBZwVnAmxBUl89MJMBDqUYLxDuwKlPDZdyKGFgSetDGreM06bpA+u59Gt
				FmbZOAMd4oVbk2l1XV0WrSFJ0M0GOs1pSUq7r5noGMYGCS3botmawNic1WvWs279JgQNKoKZSSza
				apI0oTfo4VyFMorSOZIsoz0xgZfAl79664nIp512msCQZhOHjQ9DzsUglyQJWZZRliXPe97mBaMR
				Rjz5C2+Un1x8AdI2OOVAeYJ4RAVQgVFLZVAoNKk1ZM0xlBOq+QG93gCLYBVo52k12sx15+lPzzLI
				umRjTSbGmpR4ep25GFYmFmOTeHNWjrIoMEqTZA0khJFSwJAyt7WA8/EffqFccNmvMCuaNJePMdXv
				IFXMndjay/NBMMbgrYo5sUFFU+esTJtkXjPoFZRFQSGOoKBhEkrvMHlCu9nEJyCJopSKfqeDamR1
				ZlcTCBSuiOGJKEQF9MqMq2dv5EWnvlU++ZzNuWSPPuqRXPHVz9JcmeO8ww8c+ViOMgbnPRICSZLi
				ncMbhWoYusHx6z9deqs2yBU3XUtlIWnnFK4kBEeSpijvaOU5nbl5Ws024hSucOiucPiBh/LFF35w
				s/X+01feK9++6Kf4MUs2mdPxfUIo6iJOIDEJUnoG831SZ9hz2e784QM/UjfyS37EaVtc2+uOWQgT
				HvqhF8hvrr2cRDUYOE/V70d3kbj3SlUhaWBQVly94Xo+ev4p8uqHPn+zNYYQqJwbbWiptfQ0oIOq
				mfMaV4seGJPi+w7V8aTOkEnCZHMVu+2zO/vutTeTjQa9bpeNu80y3e9y+Q3XMN2fZdk+u9HO23Sq
				+SgIW4uTxmZJjcKAEvquTzqR0/eB6zeu2eIzEAVBBYIKm5e8hpSlITgrqcO+hb81mbVZkY6xZm6W
				qbk1KKmgbQi5o8xN/Pxa1c9h6ODVyjXDnObsPD1XMBlywsyAbuHweUooPL5MuXGmYixtM5mPsbw5
				HtM+IrFXVAJam1EE5UXwXmoXSbEzM8GLoqDdbo+S/dbGtNDQSxvmzIDNCgFbBLSLfvMrJIEkTyir
				CofU7RL1OKxaekSHGEb2pjahgyXDkgbNpG2yatky9r3bXuyxajeWT65gZmaG9Zs2cMPa1Vy79kbm
				56dIx5tMNifpFD20MnEv1NwvcR6vhTRNqYqyPjAyEuHYktrG+8/+rPzXV7+AaIWTEBN7WqESiwsB
				XSsOSIhN8ImyhOAZbzZJewE/38NVsPvECo645/6s2vfutMbHueGaa7jmmqtZs2k93ek+JRWqlaBz
				A5Ugxg/FpQgI3gcIIZKBtWZs2STF2lm+/YPv3ZLk+rjnqQe89TlyQ2cNHkej2RrRG8hyvPc0koRe
				rwfK0EhzfFFyyR8v47knv0H++2//ZbvJxL/5r7fIDy4+H51qmu0Gc+UcwTuy1FK6Ao2hcp68lUBQ
				uKJEdSuO/eujuZDNc4A/uegCNnZnaYw30UrR73TJ8gTnKkQb0iyl7Fd0ZufYe3wVD7z3ffkDP9rh
				jfzAAw/hmmuuxnU9aI+1FqcqJFW4EKiKgsxabGrYMDXF2T87dwslQ0tQGqWT2qMQRAW8Wxiwo0Rh
				RIEyhF7JsrSNNZ4w1+Me++zPuW87TV0FXLCFNT771LfL2ReeS3euz9hu4xRlt8YxIdS1RCHScJSC
				sqpot9v43HPtdddtk9k+bEcaViAXKJixuh9QUbRxkdbPR57+avXu750sVWZi76Y4bpxdy7d+dy4b
				+7M1JzSM1jV6L1EjcrCzOYfsfQ+Ou+9R7J6OIw5KHekZ+QBUr2Ks0eIfH3ui+u/vnCmD2S6VVNgk
				jcBWe00iUhd8Qq2zplEozjjjDDnhhBN2qDr/pS99STqdDq1Wi16vN6pwWmsRkZhnrfNozjn6/T7P
				f/7z1RYB7emfeo187fwfMrbPSoIJuMpFjseoslhXegSUE4wT9lx1N6Zv2kjmDUcdfgTfftG/qbXA
				/25lwS//nw/K+b+5kGvW30RnfobGeBOkriyJwySGkCZI8DjvRl9AkFh2Vwr8Fh7NL373a3QjYzxb
				zhwDOv0ezgg2zXBFhasb4CXUa0cwRWDj6ht5wAGH8IgHPYiPHv9GdeU2HvY/nPleOe/XF/DHG68m
				XdbiwHvsz3Xrb8LrBQHKyISMbHunBEcgH2+zfs1a/uYTr5MvvGRzr+f4x/41n/7qyUx3Ztl99z1Z
				P7eByle0xsbozs8TVOTZKGNAKbJmzvymTfzuih3z0i6+8lI6rodtJ/WdHHMplXeIUgyqkrTViqCm
				cvAlu02u5IOPfdlm63zJWR+SU3/wNZLJJi7x+LIkRZNj6IcKbzTaWEpfoFAcsM9+fOH5H71VFJOP
				P+U16rH/+iL57ZWXkhhhrNVkquiD1jjxlNWATCekzZzQDVx94/W3vJnzHF0kqKHXoGPBRdTwTlT1
				htfooCHA1LWr2W9sD/7q0U/gkye+ZZtrPu0571RvOPvT8pXvf40bb1xLY2ULpwJOeUoJdTmR0eWr
				tMJ5j00SpqdneOf3PiNvf+zmE5vUIoLYsEOFILXHF19P1LAwpm6hB/jWx/7tLdZ8rw+dIBvnNmBa
				Ca7Ox9YZdmTIsg0QCoeuhL1X7M7HHvmK7X5fz33cU9WnTztFAgptDGXpEB/PZWTk1LqGstCZMD8/
				f6u8syRJRhXM4e+HYFZV1cg78z4WTbaYlwS44to/YZsJTjl6ZReVKJwKoyKAjMJNwXiFraC7Zop9
				x3fnMUccw7df9G/bfSAff/zr1K/eeqZ6+CEPJO+Dnxsg/QorBqtiC4OyGqyhclW8Vxb5rUGBu9kX
				+uHzvySXXXc1fTyz/S4mT0kbOSiFr53roEBbizUGP6hw8wNMz/OQQ47gsUc+go8e/8btrv0zT32z
				esajn8wD9j8EmR0wdcM6cpI4lac+QDGENgSrcUqY6XUIqSVfMcFvr/zDLV7zrUc/Qx2630FoJ/Q6
				fcIoZImbYlAWmCS63FVVYbOUxrIxVs9t4vlfeNs2Hfo3ffsTsmZ+I6adIFboDbqRTqPAlSUmSdBJ
				grEJEhS9+S65Snn00Y+4ZYfBr3/BwAohN5TiER8Yz5v4foEflLjSUVaOoBTtsXEO3O+AnUoG3/uw
				Q/HeMxj06XbmUVLPlFACvsIrwRsgs0wPOrzh6x/dPEozBrSJdSOtGXIthsKG1N6JCQobFLYUGt5y
				2N3vsV0wG9q/PPIf1UMOfQATpokqPKoKsZVruJLhcF+tSPOM3qCPsbFtampqassemrBZwn4oxhD5
				cjFt4oFKBLcDa9SdEuvq10E2Y6HFuZyxVtKwORQB3d9xCe4sTSmrEuc9SkeJIi8BX5NcjTExIvIB
				5xzWWr7xjW9sN/j85je/KUmSkOf5CLiGZNqhpzYMPauqwnvPypUrtw5oM7058vEGA19QVn1Mqhee
				7KKnHblFsRLmpns8+kEP47S//5dbdRt/7UUnqcc/7NHYQpC+w6LJkozgAsG5uIkljCoz1B7alkLO
				y669irWzUxQq0HMlhXexrGwN4txoQxtjSG0KpSetYO+J3bjgtaep9z3m5Tu89rcd90J10TvPUA88
				+L501k2TBkOCxSgz2sSYGOq44PAKKiVky8dYPbuRd/3w87f4Yr//ypPU3iv3ZHrNhlgQMQm9Tq9u
				EYqbBsAFx8CXJGMNBjbwk4t+vs21/vDCc+iZChoxH9obdIEYDhMCKE2SZvS7PcRDOd9nj8lVfOqE
				zXttP3DeqXLdupvQzZQKP0pUl8UAFSTykUQoXYUoRdJoMNgCCXJHLJnIGVs5wcTKSUxqCHiC1CfT
				aryBTtWnUI5ONWD93OYkzriGuOE3q5Ax5BrWomBe0A56U/M8+uhH8u1//syt2r+n/c371H0OvDeh
				V+KKilD5uvo+TM3EvWCTJDa0G02W55Rbei6yyFO7mXem6h+R2jvTaltF/oXIuxJybbHbyDmLQGpT
				UpWQkew4Behpz1IiwqAs0Imt97vaTNJ7uO5QtyZt3Lhxh9qchjQM5xxJkox4ZkMCbZbFnPUQKJ+4
				lb5R+89nflBO+8nXcUpQSXywXlwNZqoGF5Ba+98GRRIUxxz1cD72lNfsFHv9iy/4kHrg254qV0+v
				ZtAvMUkWn7Lz6MTE0FJi3ms44UHULQHtihuupUoUNjWMjy1nrupQ9j2kJr6ATaD00YUlIcFwt+W7
				c+z9juIPfHOnDt6R974/162+kbluiaDRefSqRBYazVEKZTWSGEJQdKn4w7V/3OLrPejQI1j7iylC
				iM3PvnTY1BDSFOcc2hrSNKVf9HE6Ix9vcOP1G3jOf71RTn3h+2/x/N9z3uflg1/4BGHS4E1V5zUg
				uAqtwNsE5zxWWfAQyordJlfxkPs9iP/lrM0JuVdcgtMBkxgKX5I1Urwr6Q76NPKUNMmoxONFSJKU
				ysElV13Biae/VopeQVU6gg8oFduF4mxIwUkgazXolQMGvqA1OcYPLzqH9YPpSH1QVc33c/HQNC1a
				LL1ehyTJkFxz480S7S64+PlchdYQttBZoogN2rjAeNri8IMP3aldcLcVu/OrPzLie3lYNIVRwMfQ
				3qYpznsCeuRhbCl/tpiRISEqkQzBbDjsJF7o2z9uoXQkJsER6rYlGYFObBSIr9HvDaiKCm7l/bN8
				+XJ63ag+MvJK688tIbbwqUW5tRACZ555pjz1qU/d4uK/+tWvyjA0HYaSxphRr2YIAe89eZ7jnEMp
				xbOfvXUVFXvNjdcy8CX9ytNYNob3HlcNwNYgs9g1lojANijOeunHb1PP1n3ueShrfz3NbGcTWW7i
				7WQ1iTH4LRECuaVi7WzRozE5Tqfss2rlCtT8IOaLqgpsQmIsVagofUmqNZlJ2Ge3vfjkE9+002v/
				6PGvUce+73ly4VW/B5OhbBILGhLB1yiFMho3GKDHEqqyolCOK6+7aouvd7+DDuUP113JtXOrKV1J
				ai1KiB5UrwsaGs0mZa9LpQITKybpbZrlvIt/ycd+dpq86mGbf7kXXX4xfV2RNFMGYUCSaDISqqrE
				JpY0ySh7fbxYWo0xio09Drn3QXzmKbcMva++8Tq01VRVSWCAaiYoa1AqYSCeRFsIGqXApClBAlfc
				eD1/uvZaYKEqpbWp7ytPCJGcmTVz5rodAp60kWFSS0gCGEXeyCgqh8OB1qg0wWARAzq3ZGNNblp/
				88phwBgVgc3U3o6OvaPDwxw7PqKayKplK3n3sX+/U/vggLvvT6qSEdFUlOCGOTQv4D1lUdDKx6jm
				SooSTGK3GnLeHOREBFP32fqaYBqLc9vXLqucj9zAOoGx+Rmq5wyIRHZBkmHMrVPhP/FJT1GfPuVz
				IjVrwC5qGh/16loDxjAoCtI0ZW5u67M/5+fnSZJk5H0NvbTYlRF7NYdhZghh9He3GnJfdcN1NMfb
				5O0GZagiryRJMNqA8+Cjh5alKXmW0e/2ufc9732b2xtOfva7VDNroolqtUZpsiSh7PexOpaFlVbY
				NKXZbNJoNLCLPsyrf/RpufamG/FGkbabrN6wLrYzIWAthEBwFWhFnucYbZDSc/B+97jNaz/isPsx
				2ZrAYgmVR9fDXCkdYVAilScbG2emO0+3GrB8t5Ws3rB2i6/1xgc/XR13xNEMNs3TJKWdNAilw5UV
				SZ6jlGK+MwutBjQSNs5torVynC4F3z7n+7d4vXN/fT66lUKmMZnBiafyMS8xdCLTvEVuMqr5gsxp
				7n/QYVsmOXZnSDNLK89ifqOMtJbSCC7RdKsSLwGtDM75GGZnFj3ZIlnewE4m6HGLtDXSVugJi5lM
				MBMJoSG0VrVorWzHwkUikAhBO/pFF1evGaWQqqLT6ZBkKUVVoI1m49QG3v/zz8kCbaOg35tjYqyB
				L4sYWvtYGAghVqGVMRhjKQYlk+MTO/39W2WwOu5ZVXsW+NjfaJRGmwSlNP1+f9RkXZblLcFsUbhm
				ai/WaI3Vpq6YxwjJe18LB2xfLlvnGWXdaaDqghi1pxREUEZjkgQngk4SesWtJ8G2W60RuAxblLyP
				1WlrDM65ETi1Wi2yLOOMM87YYsBsjBm1TA1zZ0opGo0G8/PztFotJiYm6PV6FEXBM57xjG1eQtrh
				cUrqFmlG1TDxfkHff5Fkh1Gaifb4LunZajfbpEkalSZqLTBVc3sWPPhaD2nI9xmGGBJwMmzeqW/K
				IWetzr+Z+obylUcJtPImey7f7Tave+WylXEOQj2BoiakRw6d0lilKcoyVqW0iiFbNeBj552+xS/1
				4499ibrPvvdE5gsYOFppA6NM1CiTOq8yIhMFKuXQrZTLbryaN33n30av+YxTXy/T3RmW7bEcJ64u
				jMhmtACCQjlgEMi95bB9DuZjj37ZFjdJp98h+NgShffx8CUaSQ3BKnQWCwu+qih6PXr9PiGxmFaD
				vi/p+4KeL+iHAX0p6Iei/nVAISUDP6AMZWwf8gWVL3GuwjsXG9srYkjkwPg6xPND9WIY9HoLB0Mr
				EqvxvsIX/fozq5F8uywaxKO2yWrcgcT7qJqnRl7JZlFMTY3YQrpsB23Y6Bd5dIqFjo7t9kGOUjNq
				IT8ndUFgNEVtoaXQ78RjePbTTlRJkkSPd0iAHXppeqEyOcx/AczOzt4yn/61r8nN+zUXywQZYzYr
				CLRare1/N04k9hQuevLi4+02vCGHCx/yQlYuX7FLAG2sPUZi0ygwKHGjaLX5VpBaAcNXLq5r0Z8H
				CVGaZjiTa7MIREa3nvexkpPahDcfedtVYN/0sOeqBcChlh6KZeuhSCPejRqb0zShHAyYnd26GsGx
				hz+YMVKkX9FM8qhKUechagbnMLEYwSoRZkOPb5y3MFX7Zxf/ElIi/0ocEvwCv0kWJcW9oprtszxp
				8/D7Pnira+oXfXQcBz16f9ELBZDIv/MoNHnepNFok+dNekVJ2mgs/OQNsrxBludkjQZZo0GaRVmm
				NMvJ8wZ51oi/5g2aaZNmSGmHjIZLyFxCw6e0JKVJSlMlJF7hesXNWl6iXr5J0xGRdFGmahFMbKnL
				8VZ4aIvzYbWOnKor1HonZK6GOWJZNPQMNYSe2KKmWRgYvM0cmpZFuWY1Eu8cPYN6cLfUg7yD3rm2
				y3ajiYSwGT9MVAxnqzrXNaRWWGvx3vPlL2/ePdDtdkfgNQS/4e+HyX/nXHSkjOGZz9y+mKp2IdLv
				wqIbZwhq0WuqeT0h/lliE9rt9i4BNKNNTXtYKP+iFMbazT007xHnY0J3EWANgfbm6I4IUj9Uk8QH
				7ZyPRYZdZLGX1aC0Ga112LQbb6paw0kgNYbgHcVitYSb2cee+Ap1+AH3wpQBX5Qj73JRBhEkNpIL
				gZn+HON3W8m1s2t58plvkAee9FyZKuZYsfceTE9viuBfhxwjn0TilWy8ws+XHLzHfnzo8Vuu9L73
				56eI0ZCkUegyKs+GCGzeg3MQAlYbUpuQ2RSqQBhUlOunKWYHFLMDqrmCajb+uLkSNzvALf6z+if+
				d4mbq/AzFXnfknU0WUeTzkE6D0kX0r7C9sHNDhjMdBdARkfqj5dAkqV1Mn1hDOLoVzXCoduwbxdl
				p1SttVbrrY14ZTeDTLUNILvZt1xHG7UoSg1qKoSb7Ymte3eMujgXJqhv5iaKjCZA7eyJeOqTn6yM
				0pSDIoaK1hJEKL3DE1sjh/2Xw9BzsZ1++ukyBK2YMgijczx0noY5tE6nQ7PZ3MF0wAi9dc1Qrl3m
				2vvQRg+jUJTSaDTB7ZrRV8EHjDWIJoKZj1vPGEOlw2hDBudjBXQRIBmG4alsXv7eLE1cV3i0phyU
				BJXtMkATaua21YQayIbsDR8CKs0i07sq0d5jREYSNFuzRx15DFfd9Cdu2LCBbI9J0LIgmxSG2z3y
				65wvUM2EXiacd/lv2LhhPe3xFu2JNjNrpyMvTi0KgeoTYrAkWFY0xnngPe/LD7ayljcf/Xy1x0sf
				LGJjeOm9EMRHMBOBymPSnEae4/oVg/keVadg/7vth22toDc/j1l8mIcs+CFrXQ19Khkd4iBRSClV
				ikbPoUTRk5hSSAJY0VhlycSyasXdmUzGFjhSSY5ShsIFCuciL41hp0ut2KIWDrW+DXebraOWxaC2
				4AHWn3FxlmALyf9beGcsRLGBKCYZG+1riXYRzA70E+n6/YICr4fj69QIw0TCZq6gug3Du59x4tPV
				ySefLGVZxjPro1CrTZORxzVM8A+JsqeffroMm8qTJBnJaC8Gs5vnGKuqYkc7Dqw2NTmUUINDBC2l
				dVQTTSzaKKQKKBXLqZt2gFuyI9br9ePh1wloVZeCA3bIvK9zEcMNsfiGSo0lMQZX96dtHmIIyloq
				5xBt0NYQgkf0rvHQPnDe6fJvX/ls3CzWgPKxfai+TQOgjCEUHuMDoXRk1tLI8m2+7uuOfb568n+8
				SK7/1VpC5ZBh+bvu1JAQ4sY2YCfGmO7PIRnMqRIahlJ7Nk5tIEsSiuDRWo0ADRRaGRKVkAbLIQfe
				g/dtZyhJag1d8ThUlAtXjAacWJugvOCLElc4Gjpjz91W8OTjHsNHjvqH22XgxvmfWVDfCEEhKlbX
				xGuG+tObeT2Lc1my85dyTdRhqAYTk6hq1KokIqMc2nbBbCvV/DDMCw9Hz8mOgbCuVVRGNKdhfq+O
				vtSQGmJqeojctjPRajbp9nrRK67XnqQprnSkaTryvkIII3AqioKxsbERz2yYEhoCml7U4mWtZXx8
				x3P2OjJyzUhxluFAC3Sscg7Lp7WsSVVVrLlp9S7ZkFPT0/QHRezBHLKsiTylCAoLHfaLk/xDQLPa
				YOuwbjMXX+KN4F1Un02zHGUi6/g1p3/gNqPa6tWrGVQlTmr1AmMiX0prfJ1olZhcI9EGHQKtLGO8
				vf2k5tdf/Em179774EoXlUG1isz34S1dewhpntB3fWgmlAnoZW0qLXRnprFKjw6AHj09Hcm7ypDp
				lIceceR215LZhCq4mlRbe8YBsqBoBI0qojqqCkJuE1a1J283MLtFMjwQ29xsgsmyGmwid0vqS2EU
				bm4HZLZn6pb5h1rTjtF7cTN+mdoBMBv+pQAEowia0WRztYNepQ1EVdlhuLlogvrQ0x+NhRzmR2+D
				Pf3EE5XWOgpBpAkCVN6hjcZau6BYvCiMHDagD0PSoSLt8O8OPbMh72x7lc3NAU3HxPlo7mUdbiqt
				wfvaddSjhHzpHetnbvtAhH/5+WkyNT9Nv98dJZajpxjfK4oiSP1DLXm/8LkaGHLRWIm3ZdCC1yMt
				AYytE/MSaORRgbRwJVevvu42r/2G9TfEKT1U9X4Z3tSKoG30EuqNktgEqwzNtMnLd0AbH+Dwfe5F
				UoB1CiMGMAiaUPf1iYb57lz0DDIDvXkCgbyZYxrRC4ydToIoHVVxRWPE0vApYz7jvY/6x+2upWGa
				WG8xzqDEomOgDyh6/QFKxdxImiTMz8xx/TXXckeZNgk+EEPjURPy0E+SzSqHalho2VlAG+ZuWVCB
				XQySo7yYklEIusV3W6z3r+q/uQgF1eL/7WCxwUj8jJspPCsWVf9lodAgwq4IWtI0JbGWPM1QwKDX
				R8JCD+bQO1vM+g91QaEsyxFwjZyX+teba53t0D64z6GHse76G2nnDRppBnWvVtnvgTW40uHLijzN
				EQXpeJPrZ9bz5E++4jY9iv/86imopiIfb1CVA4xA6Psoehh0XSV0+FBiMoMkmkG1UNV686Oer+69
				175QVujEQKYJVRedKZCSshyQtxoQPPPTm2i1cwaUXL7hel7/rX/d6bW/6Tsfl9/+6WJsU6GMR+Ni
				iFz7kJgEkhyd5yCBrNFkdrbDPnvtu8PvccYLP64OXXUgMltBT8hsA6pAOjYe1UwNKBUAD4NedMPK
				gmowIMkyquBJjaGan2N85XIqpTBJjgxgrEj5h8c/e4fWceR9j8Z2LXkvYTK0CfMe7zWl1pjxFiGz
				FFWJRpEmKcoanvXlt94hA3kdYJMUIxoqQUkk/VpRmCAYCWiJKQGUbLGTYIdzaBLzslFJudZCKypU
				3Qal4xBMnCtBC2VwsIWBvsMK9kIOKUoEiQSoQFUa6y06GJTourl8O2Ar9Rg8zUglZxj5RNCNBQar
				Ynud2QXP/pnPfKbqd3v0Ol3GW2PUWpUjIFvcwjSUBhq2No2NRR3FYUU0z3O01iMhxxNPPPFWefz6
				oH33Z69Vu9OdniWUDpXmUcQtz9BZGosCRCVNj+AMuExx4eW/4zU//Ped2hVP+a9XyZz0cBmYhkV0
				zV6uZ2NKCIiKP+g4Hcjr+LPY9lu5J9VcD1V5bJJClqJCrMJ5V+HFozQEPFWoKIxnbX+aC6+6ZOfz
				Nn/8DRuqGQpdUUpBVQ0Iroq3qLJolURNLB9I8gbduQ7z03Pc88CDb9X7POSQIxhXTUwJxmmakyso
				+wVkGaWPrWl6WHWUsHAz13mXoihoLlvG7Pw82lgSlaCKwKF3P4hXPHzHEqz77bk/0g3QF3Kdk6fN
				mJPMUgZ1NcsYgzVxRkGv7HP12htv8wH5p5P/RV575q3bW178QuuM1iNqxmJPRRjSFXaOfzVa38Oe
				pYKqw8KhLPWw8qFvHmJuvaw6jIqGbdOLOBuj/FxQi3lj21/0kJKhN6shyaIUxJAnV1N5ZNdkCFat
				WoWEQDkoGNsBFsRirbNhDm0YZg4Bb2sN6NsEtHcd8wJ1wF770ts4ExnuSYYPw8BNCMFFtrkKkUzZ
				TLETDaZcl5/85nxe9j8fuVUb7+mff718/xfn0NEVLlNIbggJBANiI7/JSS1HXBdgnY6tJTffhIcf
				fG9aYvDTXWzf0VAZqTdYFTsKvBJUTQIttUe3Unra84cbr+Ko9/+N/MuFp+/w2l//08/Ioe9+ilxw
				9SWU7QQZS5HM4FWc56m9xziPKSp0ryB0C3Is1XyfVpLz8ee85VbtnI897fXqHnvug58v8N0SVQoM
				HEbbWLQZ8YsWKrqLK0Slq1DaUHX7jGVNBjPzjCc5xzzoqB1ew1se+Ww1MTZO5R0VAZUlYFRd1RXE
				O6QswVUYq/Dac/Xqa3niZ1+10+7PiR99jZz5nbM49X++wpP/41Xy/rM/u2Ov5aMgpDIKqZvo0XVj
				d93c7bXCaUWlFZXWO314P37BqeJt3JfeEMcRaiEY8DrUdAuFwcTRb0FHz/Hm4WHQmKDQQS2ke4bJ
				LgPOCM6Cs1BpqNT2CxmlAa8jSCa+HqPg65+gUEGhGXJCbhsfb7E94QlPUEDs6Ei23/A+9NyGdI3F
				6hpDqsfW+j+3XbAB7r3PgXHCTRGwKrbzjBpta9FEIcoEiwVJQbUsF19zGWee/W2OP/k12910r/zO
				v8p93vpk+dbPfkCVQ8g0lQ44HSJwGRWH7irZXBi8TraGLVwmL//Lv1H3P+gQkoHH9AO5pOhKYVSc
				5B6CIxA3mNMShySP5/S047LVV/GVH32Tvz/zX7a79ud964Nyxrnf4dLVV1NkQmNFOw4dsTEPokKI
				cxEqh6ocpgpkDnTfMZE2eegDjtypTXLs/R/CinQMWwj96Q42yaGK6qhKLXghN7/9BUWSNejO98iz
				Jk2dUk7Ncf+DD+XVR59wqzbJg494IHmW0e334wWRpQQCNrGI9xT9LkXRR1tIWimbetP84g+/5sVf
				evetArUP/+xUefR7/lbO+99fUDYDg5Zw4dUX85mvncoj3/NcedfZn5Ftl+shtRqtAt4VC17ZIrJq
				qGe9jig3Ox3exqhBhkn7OssutbJzzINpAou+oy14QkrU5h7ZsDdALWQwqKOTSJjd/iP19VyKUeJ/
				gXJW6/bFaVF+EdDvKpucnBxp/W/Xk7wZTWNYQBiG31tSo92hdADAfz79rWq/VzxKNpRdQikYk9Sl
				6OFcvxjGOe/xVFQYGu2UQdlndW8jP/nf89n/LX8leyzfjb1334t2a4wky5manWFqahOznVnOOPc7
				3LhhNWSKPffdm9lBl74vkaIEq7Em6iipELBaU0m8TYZdP6gtd3785dHHccWa69hY9pFCqMoAaV1W
				r6qYoLdxEnuFijMMMsgbDS658Y9cdvUVHPaOp8m973FPVixbgQRh4Bwbu7NM9+ZYu2EtZ/z02wyk
				IF/VxjYMjoqqKhblJYgj4YgscmssVgzldI+9V+zN11520k7tmvc97qXq+JNeKedf+Vuqsk9jPKfr
				HM47bFLLFinZrNw/StTmDZzvM9EYo5jqsEd7Bd960Udv9TpOe+G71OHvfJas3XgVpJZkMsf7gA5D
				Seg4fq4iQWUW74VN1Tyf/tZpPPBtJ8hRRxzJSU/a+kzN915wslx48a856esnM93vkK5qMD6+OzOD
				DpXVdMt51vzpYq6aWsOjP/IPctS9juDdj79lQcMAyjvEVTH/qu1mQd/wkKs6BlW3JdRSLHz3tWbt
				sF8gUjdUFP/U4LRCjMZvAT+9ZgQsTtevpusvUi1e8OKf7S9uSKYdzvUSGAF4IFZitVEEE73VXWVP
				eMIT1BlnnCGdTmck97M1G1Y8h7mzYbhZVRXGGI4//ni104AG8IB73ZefXnIRvYEnadqouKEFUyt+
				jhKXQz6PDrSWtVFBMeiXXLPxeq5Zex2Na1qkaUZ3MMCLIFWFTi0TyyZYtd+eFKFgpjeHyZK6xSpu
				PqVrra4QpX1DiFrwVZBttpO86hHPUX/5vhfK1I2XMT/dgVzTSDPKsNDnp5UiiOB8RSCgtaKPorlq
				HIrAVRuv45JrLwMv5M0WebtFqYW+KxDvIFGkTQs6MOgPcKHCWnOL2yYQcCisCGG+IBsIB+5+d357
				GzbJ1176r+qAV/6lzJY9BnM9ktwiuq4aDcfI1qd1KKeFgHPCWGuCan5AMTXPXz74Lzidc3ZqDffe
				/yBuGmxkYzGDH+iY16zDgrSRUBUFXdfD2hzTSkh0iskaXFNs5KYLf8j+b3ucTDTbTLTbpMYSvMcT
				6PS7fPKbX2DdzEacUbRWjFPmio6fpe97VDYnHU9IMkPXBH75p0u55A9Xcvx7XyFfe/PmoqISPL6q
				yAlkiaWoya26fj5RiWqYW5LNSNq31syQQlHzAn3N5NfoGtz0Qu5ODaMOtQXaxuZcs80ReEG1Vg8V
				YXegMquGhHOJTcZSewNBDeemR7D0OqZ0vGaX2gknnKBOOeWUHX64w2LB0LPz3u+0d7YZoJ31oo+p
				w9/2NLmpmKVXVTG5rgPaLE6uxuqO0ZrO/NxoPp5tJYw1lxFcbJcSrVGppZFlEISqLOjLgJwML47+
				/CyNZZNYpXBao7wn+LDgIrtAgkJ7RfBgjcJtoeF35KU9/FFMnVtw8Y1XAAlap2jXp2HSePtVPq5r
				eFdrKF1BkjYi+S8B8ujuamOpjEMnCW3TxJpYsarKAf1ul+BLrFU0bBJBMkRF+aiMqqkQTOXJ+477
				7ntPzriNMksA9zngXmz646/oFRU60SQ2Iaiw0N95s+4WhSJ4Ic8yptat4aDJvTn97z6w0+s4/W/e
				qY4//c1y9sU/Z3Z6BjuWxTfSChKD8zpeFjoQrEEZhU5TumVgZjCPDDy5nyEdJLiijGPI6lYq00hp
				7rMMnSf0yoKqPw1lRTY5SdHpM+hVpEmTsRVjFEGx9sYZrp1at+UbnyjfFAEnEIZkbAkoCViR+OdB
				sLcB0JKgMCFgJU4UD0owgYWiDAJGRkCl2DJNRNeV1/gjCxLbYUH+CB9l41WAdAe8ShtHj47oS8P9
				MXRG4l4xm1FZdrU1m83NyLJby6HdHNicc2RZxlOe8pSd3qub4fPBdzuAlY1JbAkNnZGblFRZjGjU
				UFWi1pTKGhkmMVTBMfAFAynphYKu7+OSQKVKSu3QTYttJlShol/00FrTaI9TFRVGaVJjES94F0FH
				KR1FAUXVFSBde2hbHzT8mmOeqY6+/5Hs1l5BKinFfIGUQoJFOQj9kuA81hiMjb2JOjHMDzpsnN9E
				Pwyw7YR0IoemwieByg/wvqQoenS784TgGGs3GR9rY7UhOI+rHK50EMBqG1VAayXQFfk4xz3w6F2y
				Qb7x8o+rlRPLGWuNUQ5KvA/1TatvRjZa4CylOkVV4Gb7HH7gbZd7+toz3qv2aS5Hdypyp2iYOPi2
				DCFqgVmNqjW/XNGnV/UpjEOaBmkZykwos4CMWezyBs3dx8l3G0O1LfNVl9m5TVRlF9oNmnvthigh
				zVKa42OkeUpRllTeseeee3L0Mcfc8oAYi0lSAkK/6C8K1eLBVkRQG7YQmdvSKVBXDSNJtd6bw6Em
				sogPFuJ76RC2+H6G+OemXpMKYMKCKspwwLFe9LN92oaq6yHxMw8r4WokMlB7fRJB2IRdD2hPf/rT
				twtIiwFtsYzSbZ2+vvlczn/8gDri4PvSWTdDQsJYawKDpd8ZEJyg0HgvtRRJrEiKVjhfRc2tzKDz
				hIF3YOsBF66M4+aBxCQ00px2owVeKLoDnAskSQbKUDgf9fHQFC6gbEpVecrKxVabbSRy/+2vXqYe
				c+QjmKSBzFe0kha+AvGKJGuilKUaFFRlhapJthiFzSxihYEf0HM9Ckq8qpBQQahQSkjS2G/acyXz
				1YBBcDit8UqTZDljrQnG8jGs09B16K7nT/9+tnrb41+8yxIU++27H0W/YPny5bESVJQ1EVlFmjyx
				cU9ClEnKdca6P17LMfc7itP/8SO7ZB3PffSTOOrA+9BfHSXIsyRHJym22QRt8UVJYhLyZhtVCwSI
				d3UAFnlZLlSj2a5lWeCKASrUunv9AXR6yKBC6v0RSkcaNLNrN5AUnsccfSwnHX/Llq0qBAoJeGuQ
				euoXBnw9VyJGmvEBxdGcO/9Ihg4UQxVeNBi78CMqdlQIhP4A3+tjtjDUI1UKKQooCprKkHhBDUpy
				dJSL1xblwShDYtMdYliEECcwWa0xatgDCgkKK2C8oMoK+gUtm5DLHdLYQVVV5Hk+ItgOh6TcFu/s
				FoAGcNqz3qL++uF/Scs0mNs0R39+QDNvk6dNEpNhTUpZeSoXqHx067EWlVj0SEIkkLXbsSm8XxAq
				TytvkuqEuak5Nty4jmbagqDRYmjkLZrNNo1mm2Z7nKzZIm2NoZIMm+ZYk9ZL3fZn/dwJr1OPf+Cx
				HDi5F26uoup7lDc0khbjrUnSrAUBim6PJEnR9eYPSnDK45THhwonDl03B7vg6FclfVdQGUU6OcHE
				XntRKLB5k8Q26E512finGyjXdzh0jwN52iP/epdvgBtW30TpYh9cTKiaKDGUZpBkI8UHrRS+9DAI
				tLJx7nePQ3fZGl531PPUkx7yFzz0Xvdn7sZNdNfP4Qee3DbJ8nG0yvBdx2C6i/Ixr6RqLbvgI0/M
				e4cPgc7MDKGMowoTZWgmOY28Ta4SpFfheo6x5gS2VExdt4YVuskJxz2Ok5/y2i1uAm0taaOJzZuo
				RgtfeyJh5KcNVWViC46xdqefgyhFEBU7EyROUwqiCVKDGwbxgtWWLEm3SmMwiaHRatDI81hQUprc
				JKTK0mq0SVSKVbZOl0C9Kbd9oI0hzfKYCgmC8zHEDr4e6OIF8bFve9DtURbFHQJoQ/JslmWjBvXn
				POc5txldt+jyfPPvP6D2mFiF73lcz5PpDLymKNyovQRjQVkwCcqkGJOCxEGrCkMx20V7RTNt0k7b
				hL5navVGdKU47F734TGPeDR7rdwLN/B05/r0pubpT83R7RUMKs9gUDLX7eNKjwRFcILeAV7zZ57x
				OvXsRz2ZzCWo0uD6QjFfUXYqcBqjc2zSxJUeV0U10KhuoNHGoLOEJEtr5QdQNpKMaTaQxDIIgdmy
				xLbHMWkOTqN6gXZocr897sEJRz6azzzpTbv02nvqp18rG6Y3YfM0klmHswpLFyWVRCGli9LdJk54
				d3MDDtpzP0562ht26Vpe/7AXqp+97nR18Kp9mdRjhNkKP1uRVpYWDdLSQi+QhFjpXdwcX7e34r2Q
				tsZotMZpZk2UU4S+h74QOp7Bph4T2SS6MKSF4dA978HTH/ZXnPzUrT/XYlBROaFfeMSBMRnKZqRJ
				gzRtkCY5xiZoY1GmHvCxsx6aNug0Q9kUNdz/OsWaDKMzjM2ofEC0QYyFNMUlt9y7mwZdusHRD55O
				UdArCgrn6fVLil5Fd65HOXCUhaeoPGEH1uwkROXmJIU0Q2U5Km2g0wY6ydBphs0aTK5YSdJsYZuN
				XQ5WZ5111nbj2NE0s3ovb2nmwm0qCtzcfvmaU9RTv/QWufBXv6TXLcgbCalN8TpQYGMbxlCqPQSk
				qtVRlSJTFo9CFzHxmScprtD0+8L+d9+bS176RXUJ8JDP/KPMrpumnU/gch9nRSYJpa8IjUZM3qJo
				qYy+65PsYGvXmx/5N+otP/mcXHT1Jfz20t+zaWqGtN2gPd4kmFgQ0MYiEvVu4+TqqKUVfNRlayRR
				MaAsKyQxaJsiRscG/kqR2ZTumk0wX3Kv3fflUcc9lE887Y3qwnd8dZdvkEuvvoJSedJWgyIUKKPB
				uejhqHTYZ4JJUhKdxMJFpXjIYUfwO776Z7lhL33/d9Uz//sN8uOLzmdq7TzZsonYwmI9MwOQEsRQ
				s/ZlxAfzdehVlgVGW6wodNBY0eQ2I20k0DCsu2maLBgO3Wt/nviwv+ANj3zBNoE5NzlJaUlKTUM3
				KXsuSnAP64ku/t57QQYOX94GCaygkEoIRdwrcZB1rKSLMgiBhJRQCj0/QDshbCG0s3kDk+RkeRMB
				kiQjSVOCD6Q6pSrqkW4Y5n1JcNvPd1mlwYMvQ6SOEFumFnJ88afoVfS7BVW163Noc3Nz26VtLFam
				raqKFStW/HkBDeDMZ75HPf/z75CLL7+E9fPTzBbzqIZl1W4r6JY9lDKxp43Ilg/O14MTDM1mTndm
				nvkN0wx0nz0mV3LowftxzEOO5lLOBGCsr3Gr58AlZHkSW69MQAWPzgxSebSLbmTW9eTFjj/89xwX
				D8Brvvcp+c0lF3P1TdcxtWYWpx3KKpLc4vGIChgLWAXW1kONowiiVglWK7SJfYGuCgQHNmi6mzay
				KhvnPoccxCPudxRve9QL/izJiKd+8rXyo4vPx7dVzDu5iiBRJdTXirTGWIKJnpCrPBSOu03uxSef
				+YY/a4LkS8/9F/Wqsz4qv7nsEq647hpm120gzXPajUZNPq3VQoyKk+FZ6FtMTBKLTC4OFXG9gl7R
				wemUZtbisN0P5n4HHsIpz32TOp8vbnctLdMgH2iSWU+WWLxJCeKxdRAYcJEhrxRel4Su3+nPnXjN
				snwcZUvKenZtWhfORHQcY5cbBkVJVTmatslY45ZUBAmGQbfAzPYR75HK4wclWhQSBrGlL80IoYJ+
				QFfb/zpTD26uz3hrJamKxB6tzMhbFqWRoCjmKzLJaNjWLt0TX/nKV6S3SBp9W4BmraUsS5RSWx1L
				t0sBDeCU571DAbzw5HfKBb//FVetvp4Ns32ak+14iGrNLu2G4n8OpQ1ee0ynZMKl3Gv/e/DXf/EY
				Xnfs89S5/PfotZdVGctdRjLrUH3B+zi2zRAQpxEPWaUY14rUtFim8lv9AT/82H9SAG/4xiflN3/4
				HTdtXEPP9QneU/oiDoZRHrFAojEmVlONigKNoQr4bp9qUCFVYDxvs6I1xt4H3IMj7nVfPvDEl6mz
				+cyfDTQuvvJSShNQWYZTcSqSkuj1DFOKUflX4QpHqAK5Vzz4Pkfwe77+Z8+FfOwpr1YAr/zSx+S3
				l13KuqlNdF0fPShwJoyS8qFuWIycPYUXD05IxJCIoREajLWb7LFid/Zcvienv+h96ne3Yh3jpkE6
				7/HTPcRASKP0kdSqIyEM5zwqXLdin4P34uc7+Zn/6dgT1f7Pe7hUtqRQLk468gYTFCHEqV9zro/z
				ASWWZnsFreqWR61RGcZCjpp3KO9JfD2vWplYYEFhfJyjmufjLMu23yM5phLGJaW4aQavh72gkXSm
				iN0LKEOoHBO2SaNMdul+KOpJTzsCaENJoV3lncFONHK975wvyB+vv5qLfv9rOkWPop5mMxxwomoi
				bDtt8ODDH8Ap//D+W/0eH/3Fl+TVRz3zz+ZdvPrLH5B10+uY7c+xcXYj050ZOlWXMjicqnllEudW
				ZsayojXB3sv34OC7H8Ann/mO260s9Henvku+9Yuz6aSeMJ7gbEDhCb5CfEWopwGZJEOLouqVNHXG
				Po3duPztX79DylcfOPfr8vs//p4/XvO/FL5HvyzolwMGvhwNs1EoGmnORHOclePL2X1iJXffbS/+
				9YTX3DEltzuB7co9/7Gff15edfTzbvdn+aUvfUmKoqDRaIw6ALbq5SYJ/X6fNE1vtaLGLgW0Jbv9
				7P5vP1Gum1lH11SElsYZj9KBUA5QVseZCi5gdEqmUlQR2G1sOfff+96c9bcfXvpul+x2tZNOOkna
				7TZ5nm8mlLAly7KMqakpli9ffpupGotNL30Nd0571IdfJGt6s/R9SbORkWuQQY9QdqPkkhXERPGA
				5a1xkn7ATJcc2NpzCcyW7Ha3U045RZIkYXx8fKSc4WuB2GHT+TDU9N4zPT3NxMTELgWzJUC7E9u1
				69cw7wao1MQWjeBJrEZbgw8VteQG7bEJqu4AW8DyZIyjD3vQ0sNbstvdRITx8XFEZMSVHLL/F4s7
				Di1NU572tKft8ot3CdDuhPa3n36brJ/eSBUcNksIKkqfY+K4MAQoHFZZcpNRdguqXsE99jmAd/7l
				Py55Z0t2h3hnjUaDsixH7P/NgEbrzSS28zz/s6xlCdDuZPaeb39Wfnnp7yDVmMyikjhNqhQfh8co
				BcqAFxKV4HolqgiMpy2OPfKYpQe4ZLerff3rX5eyLMnzHO89ZVnGAUU3a04femree5RSfxbvbAnQ
				7oT2y8svZvX8JtKxHIwsUErscORXnFdK2kA58L0KVQj3O+gw3vrIFyx5Z0t2u9piEu1wcLAxZrNw
				czjGrigKhjM8/1y2BGh3Inv32afIletvwDcNzniKUFL6CpVoTBpnl8bOaMhNRtUt0CVMpm2O3UXK
				Hku2ZLfGlFIkSUJVVaOJTt57kiQZFQZCiC2GQ2ntXUnTWAK0O7H97De/YEM5R9VQDKQi4KhwlMFH
				rSytQRtU0GgHqTfk3nDkoQ/gtQ9/zpJ3tmS3qw17NrXWo5maQ/7ZsEfTOTdSp7XWMjk5+Wdd0xKg
				3UnsQ+d/UX73pz8w63v0VYnXPrZjaah8FaWlUVidkGDRJUwkbVpknPXSf1sCsyW7Xe1b3/qW9Pv9
				0UzNoWc2GAyw1m6WMxsCXJZlPOlJT/qz7tUlQLuzbJCzv8dAV6STTZKxHJUo8GUk0JYlWbOFwuB6
				JdZpGmTMr5vmvrtQHmjJlmxHbXZ2djNBxqIoUEqRpulmwDb8CSH82SqbS4B2J7PXfe0jctWaa3Ep
				lFRxhJl4MDrOvEzTqGFVODKVkpMg3ZL9Vu3NQ+77wKUHuGS3u21JQntxd8BivbNhHm1nB58sAdr/
				Mfv5xRexoTdDNt7A66gAggRMkqAkSsK4QQWV0DI5mTeorufwexzC6x/5vKVwc8luVzv55JNlMVF2
				MZgNfzXGEEIYUTi2Jye0BGh3EXvzjz4p12y8ieaKcZJWShCHq4ooeqcMrnT40hEKT6YSMjH4+QF7
				jK3gQYfcb+kBLtkdYouJskNAu7mHlqbpKBTd1S1OS4B2J7Uf/uJcpqsuzRVjdIseuBKci/LVQ/US
				DymadtpEehXVbJ8jD7sfr3jYM5e8syW7Xe3zn/+87MhkdOccaZrS7XZpt9u32/qWAO0OtJd+8yPy
				+6sux6WKEk9v0AOlSK1BK4WEQKItqUniBC4MrjNg1dhyPvvC9y6B2ZLdrnbGGWdIURSjcHJxw/nN
				ezWdczgXhUif+tSn3m57dQnQ7kD7+UUX4iw0l43TGfTQVpNYjdWK1Bh8FVVWo6yyEApHguXoBx21
				9PCW7Ha3Xq9HmqYjjtnNAW34+2HI2ev1+Lu/+7vb9eJdArQ7yN79nf+Sqy+/klWtZezeWo7uOJap
				Js3Souc9YyEnGyialaFRGGzHo+cqJnWTk1/wniXvbMluVzvrrLNkOHpuOKVpsd3cQxsKON7eZpe+
				qjvGzjzli+xlJyg2Ofoz65hQijAziINhUSSJI+8FrC7ITEJnU5fE5PzV4x/HZZ/8wdIDXLLb1aam
				poDIN5ufn2d7ebSiKHjxi198u1+8Szf9HWQf/OKnxOlApQJeC14LQcWBG6KiflQ5KElNQjtrYjzk
				OuFVT1xqQF+yJdua/b8BAIBeN85N8e7HAAAAAElFTkSuQmCC"
                      transform="matrix(0.3504 0 0 0.3504 370.2329 44.7566)"
                    ></image>
                    <text transform="matrix(1 0 0 1 229.0677 394.8496)">
                      <tspan
                        x="0"
                        y="0"
                        fill="#A5A5A5"
                        font-family="'Montserrat-Regular'"
                        font-size="10"
                      >
                        By earning this certificate, you have demonstrated
                        proficiency in this course
                      </tspan>
                      <tspan
                        x="-14"
                        y="12"
                        fill="#A5A5A5"
                        font-family="'Montserrat-Regular'"
                        font-size="10"
                      >
                        and are well-equipped to apply your newfound expertise
                        to real-world endeavors
                      </tspan>
                    </text>
                    <text
                      transform="matrix(1 0 0 1 43.1862 581.473)"
                      fill="#A5A5A5"
                      font-family="'Montserrat-Regular'"
                      font-size="12"
                    >
                      Verification URL: academy.doyenify.com/verify/{user?.id}
                    </text>
                    <text
                      transform="matrix(1 0 0 1 43.1864 565.1645)"
                      fill="#A5A5A5"
                      font-family="'Montserrat-Regular'"
                      font-size="12"
                    >
                      Cert ID: {user?.CertId}{" "}
                    </text>
                  </svg>
                </div>
              </div>

              <div className="flex flex-col justify-center lg:flex-row xl:flex-row 2xl:flex-row gap-10 mt-20 w-full p-10 bg-[#F2FFD8]">
                <div className="w-full lg:w-[50%] xl:w-50% 2xl:w-50% h-fit border rounded-lg shadow-md px-4 py-5 bg-white">
                  <h5 className="text-center text-[#0F4B16] font-semibold">
                    Target Audience
                  </h5>
                  <div>
                    <div className="row">
                      {course?.TargetAudience.map((item: string) => (
                        <div key={item} className="col-12">
                          <div
                            className="flex gap-2 items-start"
                            style={{
                              marginBottom: "10px",
                              padding: "10px",
                            }}
                          >
                            <img
                              src="../../images/rounded.png"
                              alt="doy academy"
                              className="w-4"
                            />
                            {item}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {course?.CourseDelivery &&
                  course?.CourseDelivery.length > 0 && (
                    <div className="w-full lg:w-[50%] xl:w-50% 2xl:w-50% h-fit border rounded-lg shadow-md px-4 py-5 bg-white">
                      <h5 className="text-center text-[#0F4B16] font-semibold">
                        Course Delivery
                      </h5>
                      <div className="row">
                        {course?.CourseDelivery.map((item: string) => (
                          <div key={item} className="col-12">
                            <div
                              className="flex gap-2 items-start"
                              style={{
                                marginBottom: "10px",
                                padding: "10px",
                              }}
                            >
                              <img
                                src="../../images/rounded.png"
                                alt="doy academy"
                                className="w-4"
                              />
                              {item}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
              </div>
            </div>
          ) : (
            <div className="flex flex-col justify-center items-center h-screen bg-[#F4F8F8]">
              <p className="font-semibold text-lg">
                Certificate with your request details cannot be found. Please
                verify that verification link is correct.
              </p>
            </div>
          )}
          <Footer />
        </>
      ) : (
        <div className="flex flex-col justify-center items-center h-screen">
          <img src="../../images/doyenifyAcademy.png" alt="Doyenify Academy" />
          <ClipLoader color={"#0F4B16"} loading={true} size={25} />
        </div>
      )}
    </div>
  );
};

export default VerifyCert;
